import React from 'react'
import { Heading } from '@offerzen/pinata-shame'
import styles from './styles'

const EducationHeading = () => <Heading className={styles.heading}>Tell us about your education and training</Heading>

export default EducationHeading
